import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";
import QmsAdminDocuments from "./QmsAdminDocuments";
import QmsAdminDocumentTypes from "./QmsAdminDocumentTypes";

export default function QmsAdminDocumentsMain(props) {
  const { divisionId } = props;
  const [selectedSection, selectSection] = useState("documents");

  const renderSubmenu = () => (
    <ul className="list-group pointer-cursor">
      {" "}
      <li
        className={`list-group-item qms-admin__submenu--item ${
          selectedSection === "documents" && "active"
        }`}
        onClick={() => selectSection("documents")}
      >
        <FontAwesomeIcon icon="file-alt" className="fa-fw mr-2" />
        Documents
      </li>
      <li
        className={`list-group-item qms-admin__submenu--item ${
          selectedSection === "categories" && "active"
        }`}
        onClick={() => selectSection("categories")}
      >
        <FontAwesomeIcon icon="sitemap" className="fa-fw mr-2" />
        Document Types
      </li>
    </ul>
  );

  return (
    <>
      <h3 className="text-muted">QMS Documented Information</h3>
      <hr className="my-2" />
      <div className="d-flex flex-row w-100">
        <div className="flex-column pr-3 border-right qms-admin__submenu">
          {renderSubmenu()}
        </div>
        <div className="flex-column pl-3 w-100">
          {selectedSection === "documents" ? (
            <QmsAdminDocuments divisionId={divisionId} />
          ) : selectedSection === "categories" ? (
            <QmsAdminDocumentTypes divisionId={divisionId} />
          ) : (
            "Select from the submenu."
          )}
        </div>
      </div>
    </>
  );
}
